import React, { useState, useEffect } from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import { decode } from 'he';
import ConvertHTMLToText from "../common/utils/html-to-text";
import { GatsbyImage } from "gatsby-plugin-image";
import IconArrowRight from "../../icons/arrow-right-small-black.svg";
import _ from 'lodash';
import InView from 'react-intersection-observer';
import Parallax from '../common/utils/animations/parallax';
import LazyLoad from 'react-lazyload';

function BlogGrid(props) {
  const [clientWidth, setClientWidth] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const data = useStaticQuery(graphql`query blogGridQuery {
  allPosts: allWordpressPost(sort: {order: DESC, fields: date}) {
    edges {
      node {
        title
        featured_media {
          alt_text
          source_url
          localFile {
            childImageSharp {
              gatsbyImageData(width: 860, layout: CONSTRAINED)
            }
          }
        }
        acf {
          lending_page_image {
            source_url
            alt_text
          }
        }
        slug
        content
        date(fromNow: true)
        categories {
          name
          slug
        }
        tags {
          name
        }
      }
    }
  }
}
`);


  useEffect(() => {
    const setValues = () => {
      setClientWidth(window.innerWidth);
    };
    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);
    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, []);

  const trimText = (text, length) => {
    let trimlength = length;
    if (clientWidth > 1678)
      trimlength = 100;
    const decodedText = decode(text);
    if (decodedText.length <= trimlength) {
      return decodedText;
    } else {
      const wordsArr = decodedText.split(" ");
      let strippedLength = 0;
      let trimmedText = "";
      for (let i = 0; i < wordsArr.length; i++) {
        strippedLength += wordsArr[i].length + 1;
        if (strippedLength < trimlength)
          trimmedText += wordsArr[i] + " ";
      }
      return trimmedText + "...";
    }
  };

  const getSuggestions = () => {
    const suggestedBlogs = [];
    const categoryPosts = props.categoryPosts ? props.categoryPosts.edges : [];
    const allPosts = data.allPosts.edges;
    const blogTitle = props.blogTitle ? props.blogTitle : "";

    for (let i = 0; i < categoryPosts.length; i++) {
      if (categoryPosts[i].node.title !== blogTitle) {
        suggestedBlogs.push(categoryPosts[i]);
      }
    }

    if (props.tag) {
      allPosts.map((post) => {
        if (_.find(post.node.tags, function (n) { if (n.name === props.tag) return true; })) {
          suggestedBlogs.push(post);
        }
        return null;
      });
    }

    for (let i = 0; i < allPosts.length; i++) {
      if (allPosts[i].node.title !== blogTitle) {
        suggestedBlogs.push(allPosts[i]);
      }
    }
    return suggestedBlogs;
  };
  const suggestedBlogs = getSuggestions();
  const triggers = [[1, 0.8], [0.9, 0.7], [0.8, 0.6]];
  return (
    <div className="blog-grid-view section-gap">
      <InView onChange={inView => setIsVisible(inView)} threshold={[0.6]}>
        {props.servicePage && <div className="blog-grid-title1">
          <div className="container">
            <div className="section-title">
              <h2>Digital Thinking</h2>
              <p>Our experts’ opinions and perspective on technology-lead digital transformation.</p>
            </div>
          </div>
        </div>}
        <div className="container">
          {props.title && props.title}
          <div className="row blog-grid-list d-flex flex-wrap">
            {suggestedBlogs.map((suggestion, i) => {
              const { content, title, featured_media } = suggestion.node;
              const { name } = suggestion.node.categories[0];
              
              let blogContent = ConvertHTMLToText({ html: decode(content) });
              const wpm = 200;
              const totalWords = blogContent.trim().split(/\s+/).length;
              const readTime = Math.ceil(totalWords / wpm);

              let lendingPageUrl, alttext;

              if (suggestion.node.acf.lending_page_image === null) {
                lendingPageUrl = suggestion.node.featured_media.source_url
                alttext = suggestion.node.featured_media.alt_text
              }
              else {
                lendingPageUrl = suggestion.node.acf.lending_page_image.source_url
                alttext = suggestion.node.acf.lending_page_image.alt_text
              }

              if (i < 3) {
                return (
                  <React.Fragment key={i}>
                    <Parallax classes="col blog-grid-item" id={"blog-grid-item" + i} key={i} triggers={triggers[i]} length={100} opacity={true}>
                      <div className="blog-grid-image">
                        <Link to={'/blog/' + suggestion.node.slug + '/'}>
                          {/* {featured_media.localFile && featured_media.localFile.childImageSharp ?
                        <LazyLoad><Img fluid={featured_media.localFile.childImageSharp.fluid} alt={featured_media.alt_text} /></LazyLoad> :
                        <LazyLoad><img src={featured_media.source_url} alt={featured_media.alt_text} /></LazyLoad>} */}
                          <LazyLoad><img src={lendingPageUrl} alt={alttext} /></LazyLoad>
                        </Link>
                      </div>

                      {/*<p className="blog-tag"><Link to={'/blog/category/' + slug + '/'}>{he.decode(name)}</Link></p>*/}
                      <p className="blog-tag">{decode(name)}
                        {/* <span className="time">{date}</span> */}
                        <span className="time">{readTime} min read</span>
                      </p>
                      <h3 className="blog-grid-title"><Link to={'/blog/' + suggestion.node.slug + '/'} title={title}> {trimText(title, 60)} </Link></h3>
                      <p className="blog-grid-disc">
                        {ConvertHTMLToText({ html: decode(content), length: 120 })}
                      </p>
                      <p className="read-link"><Link to={'/blog/' + suggestion.node.slug + '/'}>Read more <IconArrowRight /></Link></p>

                    </Parallax>
                  </React.Fragment>);
              }
              return null;
            })}
          </div>
        </div>
      </InView>
    </div>
  );
}


export default BlogGrid;